function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}

module.exports = _isTransformer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isTransformer.js
// module id = 1044
// module chunks = 8